import { defineStore } from 'pinia';
import { formModule } from '@/stores/form';

export const useSettingsAccountForm = defineStore('settingsAccountForm', () => formModule({
  fields: {
    firstName: { rules: [{ name: 'required' }], label: 'First Name' },
    lastName: { rules: [{ name: 'required' }], label: 'Last Name' },
    email: { label: 'Email' },
  },
}));
